<div class="app-page-header">
  <div class="page-title">
    <div class="container">
      <h1>Gebruikers</h1>
      <div class="actions ml-auto">
        <a class="btn btn-primary ml-auto" (click)="addItem()">toevoegen</a>
      </div>
    </div>
  </div>
</div>
<div class="container py-1">
  <div class="card">
    <div class="body">
      <ul class="list" *ngIf="users$ | async as users; else loading">
        <li *ngFor="let user of users" class="py-1">
          <a (click)="selectItem(user)">
            <div class="details">
              <div class="bold">{{ user.fullName }}</div>
              <div class="muted">{{ user.role }}</div>
            </div>

            <div class="actions">
              <a class="btn btn-primary btn-outline btn-sm btn-icon" (click)="deleteUser($event, user)">
                <img src="/assets/img/trash.svg" />
              </a>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="loader">
    <img class="loader" src="assets/img/loader-primary.svg" />
  </div>
</ng-template>
